import builder from '../builder';
import CalendarCash1 from '../../streamline-icons/light/calendar-cash-1.svg';

export default builder('IconCalendarCash1Light', CalendarCash1);
